module.exports = __webpack_public_path__ + "static/media/foodLogo.f39412d4.png";